import { render, staticRenderFns } from "./AsistenciaViajero.vue?vue&type=template&id=6ca57319"
import script from "./AsistenciaViajero.vue?vue&type=script&lang=js"
export * from "./AsistenciaViajero.vue?vue&type=script&lang=js"
import style0 from "./AsistenciaViajero.vue?vue&type=style&index=0&id=6ca57319&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports